import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { unwrapResult } from '@reduxjs/toolkit';

import { Capability } from '__types__';
import { deleteBudgetExpense } from 'store/v1/productions/productions.actions.js';
import { displayAlert, openModal } from 'store/v1/ui/ui.actions.js';
import {
  RestrictedDropdownItem,
  RestrictedDropdownV5
} from '../../../buttons/RestrictedDropdown/RestrictedDropdown';
import { Button } from 'v5/design-system/Button';
import { MoreHorizontal, Trash2 } from 'lucide-react';
import { DropdownMenuItem } from 'v5/design-system/DropdownMenu';

const ProductionBudgetExpenseOptions = ({ slot }) => {
  const dispatch = useDispatch();

  const onSlotDelete = () => {
    const canDelete =
      !slot.expenses ||
      !slot.expenses.length ||
      !slot.expenses.some(assignment => !assignment.archived);

    canDelete
      ? dispatch(
          openModal('ConfirmModal', {
            title: 'Are you sure you want to delete this expense?',
            confirmLabel: 'Confirm delete',
            onConfirm: () => {
              dispatch(
                deleteBudgetExpense({
                  production_id: slot.production_id,
                  budget_expense_id: slot.id
                })
              )
                .then(unwrapResult)
                .then(() => {
                  dispatch(
                    displayAlert('success', 'Expense slot removed successfully')
                  );
                })
                .catch(() => {
                  dispatch(displayAlert('error', 'Something went wrong'));
                });
            }
          })
        )
      : dispatch(
          openModal('AlertModal', {
            title: 'Cannot delete slot if an expense is assigned',
            description:
              'An expense slot cannot be removed if it has an expense assigned to it. You’ll need to remove the expense from the slot before you can delete it.'
          })
        );
  };

  return (
    <div className="tailwind-root contents">
      <RestrictedDropdownV5
        capabilitiesAtLeastOne={[
          Capability.PRODUCTION_READ,
          Capability.PRODUCTION_UPDATE
        ]}
        trigger={
          <Button variant="ghost" size="sm" layout="icon">
            <MoreHorizontal />
          </Button>
        }
        align="end"
      >
        <RestrictedDropdownItem capabilities={Capability.PRODUCTION_UPDATE}>
          <DropdownMenuItem onSelect={onSlotDelete}>
            <Trash2 className="text-fg-danger" />
            Remove expense
          </DropdownMenuItem>
        </RestrictedDropdownItem>
      </RestrictedDropdownV5>
    </div>
  );
};

ProductionBudgetExpenseOptions.propTypes = {
  slot: PropTypes.object
};

export default ProductionBudgetExpenseOptions;
